import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SearchService {
  private querySubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public query$: Observable<string> = this.querySubject.asObservable();

  constructor() {}

  public setQuery(query: string): void {
    this.querySubject.next(query);
  }

  public getQuery(): Observable<string> {
    return this.query$;
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/search.service.ts